/** How long runs and segments take, as the portal shows it (docs/carrier-runs.md#timing). */

/** Whole seconds as `45 s`, `5 min 30 s`, `2 h 05 min` or `3 d 4 h`; a dash when unknown. */
export function durationText(seconds: number | undefined): string {
  if (seconds === undefined || !Number.isFinite(seconds)) return "—";
  const total = Math.max(0, Math.round(seconds));
  const days = Math.floor(total / 86_400);
  const hours = Math.floor((total % 86_400) / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const rest = total % 60;
  if (days > 0) return `${days} d ${hours} h`;
  if (hours > 0) return `${hours} h ${String(minutes).padStart(2, "0")} min`;
  if (minutes > 0) return `${minutes} min ${String(rest).padStart(2, "0")} s`;
  return `${rest} s`;
}

/** A segment's duration in whole seconds; `undefined` while it is open. */
export function segmentSeconds(segment: {
  readonly startedAt: string;
  readonly endedAt?: string | undefined;
}): number | undefined {
  if (segment.endedAt === undefined) return undefined;
  return Math.max(
    0,
    Math.round((Date.parse(segment.endedAt) - Date.parse(segment.startedAt)) / 1000),
  );
}
